import React, { useState } from 'react';

const getCanvaEmbedUrl = (url) => {
  if (!url) return '';
  const basePath = url.split('?')[0];
  return `${basePath}?embed&autoplay=1&muted=1`;
};

const mobileStyles = `
  @media (max-width: 767px) {
    .faqs-desktop-layout { display: none !important; }
    .faqs-mobile-layout  { display: flex !important; }
  }
  @media (min-width: 768px) {
    .faqs-desktop-layout { display: flex !important; }
    .faqs-mobile-layout  { display: none !important; }
  }
`;

const FaqsView = () => {
  const zones = [
    { id: 1, category: 'LOCKER', label: 'Taquilla', x: '40%', y: '18%',           video_x: '-58%', video_y: '20%', url: 'https://www.canva.com/design/DAHDdlrgVsE/5eUMmf-khOQVFtS-IGwp9w/watch?utm_content=DAHDdlrgVsE&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h54ec37cc96' },
    { id: 2, category: 'SCREEN', label: 'Pantalla', x: '31%', y: '32%',           video_x: '-58%', video_y: '50%', url: 'https://www.canva.com/design/DAHDdlrgVsE/5eUMmf-khOQVFtS-IGwp9w/watch?utm_content=DAHDdlrgVsE&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h54ec37cc96' },
    { id: 3, category: 'DOOR', label: 'Puerta', x: '31%', y: '45%',               video_x: '-58%', video_y: '80%', url: 'https://www.canva.com/design/DAHDdlrgVsE/5eUMmf-khOQVFtS-IGwp9w/watch?utm_content=DAHDdlrgVsE&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h54ec37cc96' },
    { id: 4, category: 'TICKET', label: 'Ticket', x: '50%', y: '44%',             video_x: '90%',  video_y: '20%', url: 'https://www.canva.com/design/DAHDdlrgVsE/5eUMmf-khOQVFtS-IGwp9w/watch?utm_content=DAHDdlrgVsE&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h54ec37cc96' },
    { id: 5, category: 'PAYMENTS', label: 'Pago con tarjeta', x: '70%', y: '44%', video_x: '90%',  video_y: '80%', url: 'https://www.canva.com/design/DAHDdlrgVsE/5eUMmf-khOQVFtS-IGwp9w/watch?utm_content=DAHDdlrgVsE&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h54ec37cc96' },
  ];

  const categories = Array.from(new Set(zones.map(z => z.category)));

  const [activeCategory, setActiveCategory] = useState(null);
  const [selectedVideoId, setSelectedVideoId] = useState(zones[0].id);

  const selectCategory = (cat) => {
    setActiveCategory(prev => {
      const next = prev === cat ? null : cat;
      // auto-select first video of new filter
      const first = zones.find(z => next === null || z.category === next);
      if (first) setSelectedVideoId(first.id);
      return next;
    });
  };

  const categoryIcons = {
    LOCKER: '🔒',
    SCREEN: '🖥️',
    DOOR: '🚪',
    TICKET: '🎫',
    PAYMENTS: '💳',
  };

  const filteredZones = zones.filter(z => activeCategory === null || z.category === activeCategory);
  const selectedZone = zones.find(z => z.id === selectedVideoId) || filteredZones[0];

  return (
    <>
      <style>{mobileStyles}</style>

      {/* ─── DESKTOP ─────────────────────────────────────── */}
      <div className="faqs-desktop-layout" style={{ display: 'flex' }}>
      {/* Sidebar Menu */}
      <div style={{
        width: '240px',
        minWidth: '240px',
        padding: '24px 16px',
        background: '#f8f9fb',
        borderRight: '1px solid #e4e7ec',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}>
        <h1 className="mt-2 mb-1 text-vw-dark" style={{ fontSize: '18px', fontWeight: 700 }}>FAQS VIDEOS</h1>
        <p className="mb-4 text-vw-light" style={{ fontSize: '13px', lineHeight: '1.4' }}>
          Selecciona una categoría para filtrar los vídeos.
        </p>

        {/* All button */}
        <button
          onClick={() => setActiveCategory(null)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '10px 14px',
            border: '2px solid',
            borderColor: activeCategory === null ? '#001d3a' : '#dde1e7',
            borderRadius: '10px',
            backgroundColor: activeCategory === null ? '#001d3a' : '#fff',
            color: activeCategory === null ? '#fff' : '#556',
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: '13px',
            transition: 'all 0.15s',
          }}
        >
          <span>🎬</span> TODOS
        </button>

        <div style={{ height: '1px', background: '#e4e7ec', margin: '4px 0' }} />

        {categories.map(cat => {
          const isActive = activeCategory === cat;
          return (
            <button
              key={cat}
              onClick={() => selectCategory(cat)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px 14px',
                border: '2px solid',
                borderColor: isActive ? '#ffae00' : '#dde1e7',
                borderRadius: '10px',
                backgroundColor: isActive ? '#fff8e6' : '#fff',
                color: isActive ? '#001d3a' : '#556',
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: '13px',
                transition: 'all 0.15s',
                boxShadow: isActive ? '0 2px 8px rgba(255,174,0,0.25)' : 'none',
              }}
            >
              <span>{categoryIcons[cat] || '▶'}</span>
              {cat}
              {isActive && (
                <span style={{ marginLeft: 'auto', color: '#ffae00', fontSize: '10px' }}>●</span>
              )}
            </button>
          );
        })}
      </div>

      {/* Machine Image + Zones */}
      <div className="machine-container" style={{ position: 'relative', flex: 1 }}>
        <img src="/images/machines/big.png" alt="Machine" style={{ width: '100%' }} />

        {filteredZones.map(zone => {
          const embedUrl = getCanvaEmbedUrl(zone.url);

          return (
            <div key={zone.id}>
              {/* Zone Dot */}
              <div
                className="zone-dot"
                style={{ top: zone.y, left: zone.x, transform: 'translate(-50%, -50%)' }}
              />

              {/* Connector Line */}
              <svg
                className="connector-line"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              >
                <line
                  x1={zone.x}
                  y1={zone.y}
                  x2={zone.video_x}
                  y2={zone.video_y}
                  stroke="#ffae00"
                  strokeWidth="2"
                />
              </svg>

              {/* Video Container */}
              <div
                className="video-container"
                style={{
                  position: 'absolute',
                  top: zone.video_y,
                  left: zone.video_x,
                  transform: 'translateY(-50%)',
                  background: '#fff',
                  border: '1px solid #ccc',
                  padding: '10px',
                  width: '320px',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  zIndex: 20,
                }}
              >
                <div style={{ marginBottom: '8px', fontWeight: 'bold', color: '#000' }}>{zone.label}</div>
                <iframe
                  width="100%"
                  height="180"
                  src={embedUrl}
                  allow="autoplay; fullscreen"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </div>
          );
        })}
      </div>
      </div>{/* end faqs-desktop-layout */}

      {/* ─── MOBILE ──────────────────────────────────────── */}
      <div className="faqs-mobile-layout" style={{
        display: 'none',
        flexDirection: 'column',
        gap: 0,
        minHeight: '100%',
        background: '#f8f9fb',
      }}>
        {/* Category chip bar */}
        <div style={{
          display: 'flex',
          gap: 8,
          overflowX: 'auto',
          padding: '14px 16px 12px',
          background: '#fff',
          borderBottom: '1px solid #e4e7ec',
          scrollbarWidth: 'none',
          WebkitOverflowScrolling: 'touch',
        }}>
          <button
            onClick={() => { setActiveCategory(null); setSelectedVideoId(zones[0].id); }}
            style={{
              flexShrink: 0,
              padding: '6px 14px',
              borderRadius: 20,
              border: '2px solid',
              borderColor: activeCategory === null ? '#001d3a' : '#dde1e7',
              background: activeCategory === null ? '#001d3a' : '#fff',
              color: activeCategory === null ? '#fff' : '#556',
              fontWeight: 700,
              fontSize: 12,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            🎬 TODOS
          </button>
          {categories.map(cat => {
            const isActive = activeCategory === cat;
            return (
              <button
                key={cat}
                onClick={() => selectCategory(cat)}
                style={{
                  flexShrink: 0,
                  padding: '6px 14px',
                  borderRadius: 20,
                  border: '2px solid',
                  borderColor: isActive ? '#ffae00' : '#dde1e7',
                  background: isActive ? '#fff8e6' : '#fff',
                  color: isActive ? '#001d3a' : '#556',
                  fontWeight: 700,
                  fontSize: 12,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  boxShadow: isActive ? '0 2px 6px rgba(255,174,0,0.3)' : 'none',
                }}
              >
                {categoryIcons[cat] || '▶'} {cat}
              </button>
            );
          })}
        </div>

        {/* Video selector list + player */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 16px 24px' }}>
          {/* Video picker */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>
            {filteredZones.map(zone => {
              const isSelected = selectedZone && selectedZone.id === zone.id;
              return (
                <button
                  key={zone.id}
                  onClick={() => setSelectedVideoId(zone.id)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    padding: '12px 14px',
                    borderRadius: 12,
                    border: '2px solid',
                    borderColor: isSelected ? '#ffae00' : '#dde1e7',
                    background: isSelected ? '#fff8e6' : '#fff',
                    color: '#001d3a',
                    fontWeight: isSelected ? 700 : 500,
                    fontSize: 14,
                    cursor: 'pointer',
                    textAlign: 'left',
                    boxShadow: isSelected ? '0 2px 8px rgba(255,174,0,0.25)' : 'none',
                    transition: 'all 0.15s',
                  }}
                >
                  <span style={{
                    width: 32, height: 32, borderRadius: 8,
                    background: isSelected ? '#ffae00' : '#f0f1f3',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 16, flexShrink: 0,
                  }}>
                    {categoryIcons[zone.category] || '▶'}
                  </span>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>{zone.label}</div>
                    <div style={{ fontSize: 11, color: '#8892a0', marginTop: 1 }}>{zone.category}</div>
                  </div>
                  {isSelected && <span style={{ marginLeft: 'auto', color: '#ffae00', fontSize: 18 }}>▶</span>}
                </button>
              );
            })}
          </div>

          {/* Player */}
          {selectedZone && (
            <div style={{
              borderRadius: 14,
              overflow: 'hidden',
              border: '1px solid #e4e7ec',
              background: '#fff',
              boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
            }}>
              <div style={{
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                borderBottom: '1px solid #f0f1f3',
              }}>
                <span style={{ fontSize: 20 }}>{categoryIcons[selectedZone.category] || '▶'}</span>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15, color: '#001d3a' }}>{selectedZone.label}</div>
                  <div style={{ fontSize: 11, color: '#8892a0' }}>{selectedZone.category}</div>
                </div>
              </div>
              <iframe
                key={selectedZone.id}
                width="100%"
                height="220"
                src={getCanvaEmbedUrl(selectedZone.url)}
                allow="autoplay; fullscreen"
                allowFullScreen
                loading="lazy"
                style={{ display: 'block', border: 'none' }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FaqsView;

